const ja = {
  "srv_general_unknown": "問題が発生しました。もう一度お試しください。",
  "srv_general_network": "ネットワークエラーです。接続を確認してください。",
  "srv_general_timeout": "リクエストがタイムアウトしました。もう一度お試しください。",
  "srv_general_not_found": "見つかりません",
  "srv_general_invalid_id": "無効なidです",
  "srv_general_invalid_json": "無効なJSONです",
  "srv_auth_admin_only": "管理者のみ",
  "srv_auth_owner_only": "所有者のみアクセス可能",
  "srv_auth_unauthorized": "権限がありません",
  "srv_auth_not_authenticated": "認証されていません",
  "srv_auth_invalid_token": "無効なトークンです",
  "srv_auth_session_expired": "リフレッシュトークンがありません",
  "srv_auth_token_expired": "トークンの有効期限が切れています",
  "srv_auth_device_signed_out": "このデバイスはサインアウトされました",
  "srv_auth_invalid_login": "ユーザー名/メールアドレスまたはパスワードが無効です",
  "srv_auth_wrong_password": "現在のパスワードが正しくありません",
  "srv_auth_email_already_exists": "メールアドレスはすでに登録されています",
  "srv_auth_email_taken_other": "このメールアドレスは現在別のアカウントで使用されています",
  "srv_auth_same_email": "すでに現在のメールアドレスです",
  "srv_auth_same_username": "すでに現在のユーザー名です",
  "srv_auth_username_taken": "ユーザー名はすでに使用されています",
  "srv_auth_username_invalid": "ユーザー名は3〜20文字の英字、数字、またはアンダースコアで入力してください",
  "srv_auth_user_not_found": "ユーザーが見つかりません",
  "srv_auth_password_mismatch": "パスワードが一致しません",
  "srv_auth_password_weak": "新しいパスワードは8文字以上で、英字と数字を含めてください",
  "srv_auth_password_same": "新しいパスワードは現在のパスワードと異なるものにしてください",
  "srv_auth_rate_limited": "試行回数が多すぎます。しばらくしてからお試しください。",
  "srv_auth_signup_rate_limited": "このネットワークからの登録が多すぎます。しばらくしてからお試しください。",
  "srv_auth_verify_link_invalid": "無効または使用済みの認証リンクです",
  "srv_auth_verify_link_expired": "認証リンクの有効期限が切れています。新しいリンクをリクエストしてください。",
  "srv_auth_email_already_verified": "メールアドレスはすでに認証済みです。",
  "srv_auth_verification_sent": "認証メールを送信しました。",
  "srv_auth_email_change_sent": "新しいメールアドレスに認証リンクを送信しました。変更を完了するには確認してください。",
  "srv_auth_reset_link_invalid": "無効または期限切れのリセットリンクです",
  "srv_auth_reset_sent": "アカウントが存在する場合、リセットリンクを送信しました。",
  "srv_auth_password_updated": "パスワードを更新しました。新しいパスワードでサインインしてください。",
  "srv_auth_password_changed": "パスワードを変更しました。他のデバイスで再度サインインしてください。",
  "srv_auth_signed_out_all": "すべてのデバイスからサインアウトしました",
  "srv_auth_signed_out_others": "他のすべてのデバイスからサインアウトしました",
  "srv_auth_device_revoked": "デバイスをサインアウトしました",
  "srv_subscription_required": "この機能はPremiumメンバー向けです",
  "srv_subscription_plan_unavailable": "テストプランは利用できません。",
  "srv_subscription_order_not_found": "注文が見つかりません",
  "srv_payment_provider_unreachable": "決済プロバイダーに接続できませんでした。もう一度お試しください。",
  "srv_payment_invoice_failed": "決済プロバイダーで請求書を作成できませんでした。もう一度お試しください。",
  "srv_payment_not_configured": "暗号資産決済ゲートウェイはまだ設定されていません。NOWPayments APIキーを追加してください。",
  "srv_payment_invalid_signature": "無効な署名です",
  "srv_exchange_connection_not_found": "接続が見つかりません",
  "srv_exchange_unsupported": "未対応の取引所です",
  "srv_exchange_unreachable": "サーバーから取引所に接続できません",
  "srv_exchange_key_not_readonly": "このAPIキーには取引/出金権限があります。READ-ONLYキーを作成してください（TradeとWithdrawを無効化）。",
  "srv_exchange_verify_first": "ライブ取引を有効にする前に接続を確認してください",
  "srv_insufficient_balance": "金額が利用可能残高を超えています",
  "srv_trade_amount_positive": "金額は0より大きくする必要があります",
  "srv_trade_invalid_withdrawal": "無効な出金額です",
  "srv_trade_bot_needs_tp_sl": "ボットにはStop LossとTake Profitの両方が必要です",
  "srv_trade_no_position": "売却できるオープンポジションがありません",
  "srv_trade_position_not_found": "ポジションが見つかりません",
  "srv_trade_symbol_required": "シンボルは必須です",
  "srv_trade_invalid_symbol": "無効なシンボルです",
  "srv_trade_invalid_interval": "無効な期間",
  "srv_trade_verify_email": "取引を開始する前にメール認証を完了してください。",
  "srv_trade_verify_email_auto": "自動取引を有効にする前にメール認証を完了してください。",
  "srv_trade_demo_min": "デモ残高の最小額は100です",
  "srv_trade_demo_max": "デモ残高が大きすぎます（最大10,000,000）",
  "srv_trade_leverage_confirm": "20xを超えるレバレッジには二重確認が必要です",
  "srv_trade_high_risk_confirm": "15%を超えるリスクには高リスク確認が必要です",
  "srv_trade_high_liquidation_risk": "清算リスクが高いです",
  "srv_trade_no_fee": "手数料なし（7日以上保有）。",
  "srv_insufficient_data": "このバックテストにはローソク足データが不足しています",
  "srv_notification_not_found": "通知が見つかりません",
  "srv_nft_image_failed": "画像生成に失敗しました",
  "ntf_cloud_enabled": "クラウド取引を有効化しました — ボットは24/7稼働します。",
  "ntf_cloud_disabled": "クラウド取引を無効化しました。",
  "srv_trade_no_price": "{symbol}の価格を取得できません",
  "srv_trade_risk_lock": "リスク制限：1取引あたり残高の最大{pct}%",
  "srv_trade_max_leverage": "{symbol}の最大レバレッジは{max}xです",
  "srv_trade_risk_range": "{symbol}のリスクは1%～{max}%で設定してください",
  "srv_payment_unsupported_currency": "未対応の通貨です。次から選択してください：{list}",
  "srv_exchange_unsupported_named": "未対応の取引所：{name}",
  "srv_auth_username_cooldown": "ユーザー名は{days}日後に再変更できます",
  "srv_exchange_connection_error": "接続エラー：{error}",
  "srv_trade_early_fee": "早期出金手数料5%（{fee}）が適用されました。",
  "ntf_risk_drawdown": "最大ドローダウン{dd}%が上限{limit}%に達しました。全ポジションを決済し、ボットを停止しました。",
  "ntf_risk_losses": "{count}連敗しました。ボットを停止しました。再開するには確認してください。",
  "ntf_cooldown": "{count}連敗後のクールダウン中 — 新規エントリーを{minutes}分間停止します。",
  "ntf_trade_opened": "取引開始：{symbol} {timeframe} · スコア {score} · {leverage}",
  "ntf_nft_opened": "NFTポジション開始（デモ）：{name}",
  "ntf_nft_closed": "NFTポジション決済（デモ）：P&L {pnl}",
  "ntf_trade_closed": "{reason}：{symbol}を決済 · P&L {pnl}",
  "ntf_opportunity": "⚠️ {symbol} · {timeframe} · {action} · スコア {score}。エントリー ${entry} / TP ${tp} / SL ${sl}。情報提供のみであり、投資助言ではありません。",
  "app_name": "FIREBIRD AI",
  "tagline": "AIによる暗号資産＆NFT取引",
  "login": "ログイン",
  "register": "新規登録",
  "logout": "ログアウト",
  "email": "メールアドレス",
  "password": "パスワード",
  "name": "名前",
  "welcome_back": "おかえりなさい、トレーダーさん",
  "create_account": "アカウントを作成",
  "no_account": "アカウントをお持ちでない方は？",
  "have_account": "すでにアカウントをお持ちですか？",
  "account_created": "アカウントを作成しました — $100のデモ資金をご用意しました",
  "loading": "読み込み中…",
  "demo_mode": "デモモード",
  "demo_balance": "デモ残高",
  "nav_dashboard": "ダッシュボード",
  "nav_charts": "ライブチャート",
  "nav_signals": "AIシグナル",
  "nav_autotrade": "自動トレード",
  "nav_manual": "手動トレード",
  "nav_scanner": "ミームコインスキャナー",
  "nav_backtest": "5×5バックテスト",
  "nav_positions": "ポジションとレポート",
  "nav_nft": "NFTコレクション",
  "nav_assistant": "AIアシスタント",
  "nav_settings": "取引所と設定",
  "nav_subscription": "プレミアムプラン",
  "subscription_subtitle": "プレミアムトレーディングインテリジェンスを解放 — 暗号資産でお支払い。",
  "current_plan": "現在のプラン",
  "premium": "プレミアム",
  "free_plan": "無料プラン",
  "renews_on": "更新日",
  "active": "有効",
  "best_value": "最もお得",
  "plan_monthly": "月額",
  "plan_annual": "年額",
  "plan_test": "テスト",
  "days": "日",
  "pay_with_crypto": "暗号資産で支払う",
  "opening_checkout": "チェックアウトを開いています…",
  "gateway_not_ready": "暗号資産決済ゲートウェイはまだ設定されていません。NOWPaymentsのAPIキーが追加されるとプレミアム決済が有効になります。",
  "premium_only": "プレミアム限定",
  "premium_gate_desc": "この機能はFireBirdプレミアムに含まれます。アップグレードすると、すべてのAIシグナル、自動トレード、チャンススキャナーが利用できます。",
  "go_premium": "プレミアムにアップグレード",
  "billing_history": "請求履歴",
  "no_invoices": "請求書はまだありません。暗号資産のお支払いはここに表示されます。",
  "date": "日付",
  "plan_col": "プラン",
  "amount_col": "金額",
  "status_col": "ステータス",
  "view_invoice": "請求書を表示",
  "check_status": "支払い状況を確認",
  "checking": "確認中…",
  "payment_still_pending": "支払いはまだ確認されていません。自動的に確認を続けます。",
  "status_paid": "支払い済み",
  "status_created": "保留中",
  "status_partially_paid": "一部支払い済み",
  "status_expired": "期限切れ",
  "status_failed": "失敗",
  "status_refunded": "返金済み",
  "status_cancelled": "キャンセル済み",
  "status_canceled": "キャンセル済み",
  "payment_processing": "支払いを検出しました — プレミアムプランを有効化しています…",
  "payment_success": "プレミアムが有効になりました。ようこそ！",
  "payment_cancelled": "支払いがキャンセルされました。",
  "payment_error": "チェックアウトを開始できませんでした。もう一度お試しください。",
  "popup_blocked": "チェックアウトの準備ができました。新しいタブが開かない場合は、下のリンクをご利用ください。",
  "checkout_opened_hint": "チェックアウトを新しいタブで開きました。見つかりませんか？",
  "open_checkout": "チェックアウトを開く",
  "pay_currency_label": "支払い方法",
  "pay_currency_hint": "Solana上のUSDCとBSC上のBNBに対応しています。選択した資産はチェックアウト時に固定されます。",
  "feat_signals": "すべてのAIシグナル（暗号資産、シットコイン、NFT）",
  "feat_autotrade": "リスク管理付き自動トレード",
  "feat_scanner": "ミームコイン＆チャンススキャナー",
  "feat_alerts": "スマートメールアラート",
  "feat_priority": "優先シグナル配信",
  "feat_save": "月額と比べて2ヶ月分が無料",
  "feat_test_quick": "1回限りの$1テスト — 本番の支払いフローを検証します",
  "demo_account_settings": "デモアカウント設定",
  "demo_settings_desc": "カスタムデモ残高を設定し、ペーパートレードアカウントをリセットします。影響するのはデモデータのみで、サブスクリプションや実際の取引には一切影響しません。",
  "custom_demo_balance": "カスタムデモ残高 (USDC)",
  "demo_min_hint": "デフォルト 500 · 最小 100",
  "reset_demo_account": "デモアカウントをリセット",
  "reset_demo_confirm_title": "デモアカウントをリセットしますか？",
  "reset_demo_confirm_desc": "デモ残高を${bal}に設定し、すべてのデモ取引と損益履歴を削除し、ドローダウン、停止、クールダウンの状態をクリアします。この操作は元に戻せません。サブスクリプションと実データには影響しません。",
  "demo_reset_done": "デモアカウントをリセットしました — 残高を${bal}に設定しました",
  "demo_min_balance_error": "デモ残高の最小額は100です",
  "nav_guide": "初心者ガイド",
  "owner_console": "オーナーコンソール",
  "total_value": "総資産価値",
  "cash": "現金",
  "holdings": "保有資産",
  "unrealized_pnl": "未実現損益",
  "top_signals": "トップAIシグナル",
  "market_overview": "マーケット概況",
  "whale_activity": "クジラとスマートマネー",
  "market_pulse": "マーケットパルス",
  "news_up": "{name}が24時間で{pct}%急騰",
  "news_down": "{name}が24時間で{pct}%下落",
  "kind_cex": "CEX",
  "kind_iranian_cex": "イラン系CEX",
  "kind_dex": "DEX",
  "price": "価格",
  "change_24h": "24時間",
  "score": "スコア",
  "action": "アクション",
  "buy": "買い",
  "sell": "売り",
  "hold": "ホールド",
  "timeframe": "時間足",
  "symbol": "シンボル",
  "amount_usd": "金額 (USD)",
  "open_position": "ポジションを開く",
  "close": "決済",
  "no_positions": "オープンポジションはありません",
  "entry": "エントリー",
  "current": "現在値",
  "exit": "エグジット",
  "reason": "理由",
  "pnl": "損益",
  "win_rate": "勝率",
  "total_trades": "総取引数",
  "total_pnl": "総損益",
  "wl": "勝 / 負",
  "open_label": "オープン",
  "run_backtest": "バックテストを実行",
  "running": "実行中…",
  "bt_subtitle": "戦略を時間足ごとに5つの過去ウィンドウでテストしました。",
  "window_results": "ウィンドウ結果",
  "window": "ウィンドウ",
  "trades": "取引数",
  "return_label": "リターン",
  "max_drawdown": "最大ドローダウン",
  "auto_trade_on": "自動トレード稼働中",
  "auto_trade_off": "自動トレードオフ",
  "enable_autotrade": "自動トレードを有効にする（デモ）",
  "reset_demo": "デモをリセット ($100)",
  "activity_log": "アクティビティログ",
  "waiting_signals": "シグナルを待っています…",
  "enable_to_start": "自動トレードを有効にして開始",
  "reauthorize_bot": "ボットを再認可",
  "leverage": "レバレッジ",
  "high_leverage_warning": "高レバレッジ — 証拠金をすべて失う可能性があります（ロスカット）。",
  "bot_description": "ボットは15m / 1h / 4hの全銘柄をスキャンし、最良のシグナルでエントリー（リスクリワード2:1、ストップ必須）し、デモモードでトレイリングテイクプロフィットによりポジションを管理します。",
  "rule_rr": "リスクリワード 2:1（ストップ必須）",
  "rule_max_concurrent": "最大2件の同時自動トレード",
  "rule_leverage": "自動レバレッジ ≤ 10x · 手動 ≤ 50x",
  "rule_circuit": "ドローダウン20%でサーキットブレーカー",
  "rule_halt": "5回連続の損失で停止",
  "rule_scan": "全銘柄・全時間足をスキャン",
  "rule_entry": "{tfs}でエントリースコア ≥ {score}",
  "rule_cooldown": "{losses}回連続の損失後に{min}分間のクールダウン",
  "risk_status": "リスク状態",
  "risk_mode_active": "稼働中",
  "risk_mode_halted": "停止中",
  "consecutive_losses_label": "連続損失回数",
  "drawdown_label": "ドローダウン",
  "open_positions_label": "オープンポジション",
  "max_concurrent_reached": "同時トレードの上限に達しました。",
  "bot_reauthorized": "ボットを再認可しました。自動トレードを再度有効にできます。",
  "cloud_trading": "クラウドトレード",
  "enable_cloud": "クラウドトレードを有効にする",
  "disable_cloud": "クラウドトレードを無効にする",
  "cloud_status": "クラウドの状態",
  "cloud_on": "24時間365日稼働中 (24/7)",
  "cloud_off": "オフ",
  "cloud_desc": "ボットは当社のサーバーで 24/7 稼働し、お使いの端末の電源がオフでも動き続けます。",
  "notifications": "通知",
  "no_notifications": "通知はまだありません",
  "mark_all_read": "すべて既読にする",
  "connect_exchange": "取引所を接続",
  "api_key": "APIキー",
  "api_secret": "APIシークレット",
  "api_key_optional": "APIキー（公開価格の場合は任意）",
  "connect": "接続",
  "test": "テスト",
  "remove": "削除",
  "verified": "確認済み",
  "not_verified": "未確認",
  "connected_exchanges": "接続済みの取引所",
  "aggregated_balances": "残高 · すべての取引所",
  "aggregated_prices": "ライブ価格 · すべての取引所",
  "no_connections": "接続された取引所はまだありません。",
  "connect_wallet": "ウォレットを接続",
  "wallet_connected": "ウォレット接続済み",
  "wallet_note": "ノンカストディアル — 秘密鍵を保存することはありません。",
  "wallet_security": "ウォレットとセキュリティ",
  "wallet_never_ask": "秘密鍵やシードフレーズをお尋ねすることはありません。",
  "disconnect_wallet": "ウォレットを切断",
  "switch_chain": "チェーンを切り替え",
  "native_balance": "ネイティブ残高",
  "wallet_chain": "ネットワーク",
  "dex_onchain": "DEX（オンチェーン）",
  "sign_in_wallet": "ウォレットでサインイン",
  "waiting_signature": "ウォレットの署名を待っています…",
  "dex_demo_note": "ご自身のウォレットで署名します — 鍵が端末から外に出ることはありません。",
  "view_on_explorer": "エクスプローラーで表示",
  "wallet_required_dex": "オンチェーンで取引するにはウォレットを接続してください。",
  "tx_pending": "トランザクション保留中…",
  "tx_confirmed": "トランザクション確認済み",
  "tx_failed": "トランザクション失敗",
  "connected_label": "接続済み",
  "not_connected_label": "未接続",
  "copy_address": "アドレスをコピー",
  "readonly_warning": "APIキーは読み取り専用権限で作成してください。出金と取引の権限は無効にしてください。",
  "cex_security_notice": "秘密鍵を保存することも、出金権限を求めることも決してありません。",
  "api_passphrase_optional": "パスフレーズ（任意）",
  "read_only_label": "読み取り専用",
  "how_to_create_key": "読み取り専用キーの作成方法",
  "connected_wallets": "接続済みのウォレット",
  "no_wallet_connected": "ウォレットは接続されていません。",
  "no_exchange_linked": "連携された取引所はありません。",
  "smart_contract_allowances": "スマートコントラクトの承認",
  "no_allowances": "有効な承認はありません。",
  "revoke": "取り消す",
  "max_spend": "最大支出額",
  "link_readonly_hint": "「取引所を接続」パネルで読み取り専用キーを連携してください。",
  "vpn_notice": "このマーケットプレイスは、一部の地域のユーザーにVPNが必要な場合があります。",
  "ir_friendly": "イラン対応",
  "best_price": "最良価格",
  "marketplace_listings": "マーケットプレイスの出品",
  "tab_opps": "チャンス",
  "opportunities": "チャンス",
  "high_opportunity": "高チャンス",
  "alerts_triggered_today": "本日発生したアラート",
  "score_range": "スコア範囲",
  "timeframe_label": "時間足",
  "direction_label": "方向",
  "risk_disclaimer_title": "リスクに関する注意",
  "risk_disclaimer": "シグナルは情報提供のみを目的としており、投資助言ではありません。シットコインの98%は失敗します。必ずストップロスを使ってください。1回の取引で資金の1～5%を超えるリスクは取らないでください。",
  "no_opportunities": "現在チャンスはありません。スキャナーは5分ごとに実行されます。",
  "alerts_title": "アラート",
  "enable_scanner": "自動スキャナーを有効にする",
  "min_score_label": "最小スコア",
  "monitor_timeframes": "監視する時間足",
  "max_alerts_day": "1日の最大アラート数",
  "notify_method_label": "通知方法",
  "notify_in_app": "アプリ内のみ",
  "notify_in_app_email": "アプリ内 + メール",
  "alert_history_title": "アラート履歴",
  "no_alert_history": "アラートはまだありません。",
  "nft_markets": "NFTマーケットプレイス",
  "iran_friendly": "イラン対応",
  "key_security_note": "鍵はサーバー上で暗号化され、ブラウザに保存されることはありません。",
  "exchange": "取引所",
  "no_balances": "残高がありません（APIキーを追加するとライブ残高を読み込めます）。",
  "safety": "安全性",
  "opportunity": "チャンス",
  "holders": "ホルダー",
  "verdict": "判定",
  "coin": "銘柄",
  "chain": "チェーン",
  "scanning": "スキャン中…",
  "scanner_subtitle": "取引可能な流動性を持つ厳選ミームコイン（スコア ≥ 75）。不明または詐欺トークンは表示されません。",
  "safety_note": "安全性 = 流動性ロック + ミント権限の放棄 + ホルダー分布（目安であり、投資助言ではありません）。",
  "ask_ai": "Firebird AIに質問...",
  "send": "送信",
  "chat": "チャット",
  "ai_empty": "銘柄、時間足、戦略について質問できます。ここにある内容はすべて投資助言ではありません。",
  "ai_thinking": "Firebird AIが考えています…",
  "ai_error": "申し訳ありません。現在お答えできませんでした。",
  "score_coin": "この銘柄をスコア化",
  "any_coin_symbol": "任意の銘柄シンボル",
  "analyzing": "分析中…",
  "entry_strategy": "エントリー",
  "exit_strategy": "エグジット",
  "risk": "リスク",
  "signals_subtitle": "AI + テクニカルスコアリング（全銘柄）",
  "momentum": "モメンタム",
  "simulated_feed": "シミュレーションフィード",
  "collection": "Firebird 555 コレクション",
  "nft_subtitle": "Firebird / フェニックス — 555点 · レジェンダリーレア 6点 · それぞれに破壊と再生の物語があります",
  "rares": "レジェンダリーレア",
  "floor_price": "フロア価格",
  "minted": "ミント数",
  "total_supply": "総供給量",
  "rarity": "レアリティ",
  "bt_download": "ダウンロード",
  "bt_stop_loss": "損切り（TP = 2× SL）",
  "bt_min_score": "最小シグナルスコア",
  "bt_share": "共有",
  "bt_history": "保存済みバックテスト",
  "bt_card_saved": "結果カードをダウンロードしました",
  "bt_compare_tf": "時間足を比較",
  "bt_best": "ベスト",
  "bt_worst": "ワースト",
  "bt_run_all": "全コインを実行",
  "bt_by_section": "セクション別結果",
  "bt_per_coin": "コイン別結果",
  "bt_avg_return": "平均リターン",
  "bt_skipped": "スキップ（データ不足）",
  "bt_sec_major": "主要通貨",
  "bt_sec_shitcoin": "草コイン",
  "bt_sec_meme": "ミーム",
  "bt_sec_nft": "NFTトークン",
  "bt_sec_other": "その他",
  "bt_data_live": "LIVE市場データ",
  "bt_data_simulated": "SIMULATEDデータ（LIVE市場データなし）",
  "risk_per_trade": "1取引あたりのリスク",
  "max_amount": "最大",
  "tier_major": "メジャー",
  "tier_mid": "中型",
  "tier_meme": "ミーム/ポンプ",
  "high_risk_ack": "これがハイリスクな取引（残高の15%超）であることを理解しています。",
  "lev_warn_yellow": "ロスカットリスク高",
  "lev_warn_red": "極端なレバレッジ — ロスカットリスクが非常に高いです。二重確認が必要です。",
  "lev_ack": "証拠金をすべて失う可能性があることを理解しています。",
  "lev_confirm_again": "極端なレバレッジ：もう一度押して確認してください。",
  "confirm_again": "もう一度確認",
  "high_risk_required": "ハイリスクの確認にチェックを入れてください。",
  "lev_ack_required": "極端なレバレッジの警告を確認してください。",
  "trait_element": "エレメント",
  "trait_aura": "オーラ",
  "trait_background": "背景",
  "prev": "前へ",
  "next": "次へ",
  "all": "すべて",
  "save": "保存",
  "risk_lock": "リスクロック",
  "max_position": "最大ポジション %",
  "trailing_stop": "トレイリングストップ %",
  "take_profit": "テイクプロフィット %",
  "stop_loss": "ストップロス %",
  "risk_strategy": "リスクと戦略",
  "exchanges": "取引所接続",
  "connected": "接続済み",
  "disconnected": "未接続",
  "withdraw_demo_wallet": "出金（デモウォレット）",
  "withdraw_fee_note": "最後の入金から7日以内の出金には、5%の早期出金手数料（オーナー取り分）がかかります。",
  "withdraw": "出金",
  "trade_history": "取引履歴",
  "no_closed_trades": "決済済みの取引はまだありません",
  "owner_subtitle": "全ユーザーの閲覧専用パフォーマンス · コミッション台帳（利益取引ごとに2%、週次精算 · 早期出金手数料5%）",
  "total_users": "総ユーザー数",
  "total_commission": "コミッション合計",
  "this_week": "今週",
  "total_volume": "総取引量",
  "all_time": "累計",
  "settles_weekly": "週次精算",
  "commission_breakdown": "コミッションの内訳",
  "from_trade_profits": "取引利益から (2%)",
  "from_withdrawal_fees": "早期出金手数料から (5%)",
  "owner_rate": "オーナー取り分率",
  "settlement": "精算",
  "early_exit_fee": "早期退出手数料",
  "weekly": "週次",
  "daily_accrual": "日次発生額",
  "no_commission_yet": "コミッションはまだありません — 利益取引で発生します。",
  "users_performance": "ユーザーパフォーマンス（閲覧専用）",
  "col_user": "ユーザー",
  "col_role": "ロール",
  "col_joined": "登録日",
  "col_volume": "取引量",
  "col_balance": "残高",
  "role_owner": "オーナー",
  "role_user": "ユーザー",
  "guide_intro": "Firebird AI Tradeへようこそ。以下の手順で安全に始めましょう。",
  "guide_step": "ステップ",
  "guide1_title": "デモモードがオンです",
  "guide1_desc": "$100のデモ残高で始めます。ご自身の安全な鍵で実取引を明示的に有効にするまで、実際のお金は使われません。",
  "guide2_title": "ダッシュボードを確認",
  "guide2_desc": "ポートフォリオの価値、トップAIシグナル、マーケット概況、クジラの動き、マーケットパルスを一か所で確認できます。",
  "guide3_title": "AIシグナルをチェック",
  "guide3_desc": "銘柄はRSI、SMAのクロス、複数の時間足にわたるモメンタムをもとに0～100でスコア化されます。",
  "guide4_title": "AIアシスタントに質問",
  "guide4_desc": "Firebird AI Core (GPT-5.6) から、銘柄スコアとエントリー/エグジット戦略、リスクメモを取得できます。",
  "guide5_title": "自動トレードを試す（デモ）",
  "guide5_desc": "強いシグナルでボットに買いポジションを開かせ、トレイリングストップ / テイクプロフィットで管理させます。",
  "guide6_title": "ミームコインをスキャン",
  "guide6_desc": "安全性スコアが高い取引可能なミームコインのみを表示します — 不明または詐欺トークンは表示されません。",
  "guide7_title": "Firebird 555 NFTを探索",
  "guide7_desc": "555点のフェニックスコレクションとレジェンダリーレア 6点をご覧いただけます。",
  "disclaimer": "デモ/サンドボックスモードです。ここにある内容はすべて投資助言ではありません。いかなるシステムも将来の勝率を保証できません。",
  "src_manual": "手動",
  "src_auto": "自動",
  "tier_legendary": "レジェンダリー",
  "tier_epic": "エピック",
  "tier_rare": "レア",
  "tier_common": "コモン",
  "verdict_tradeable": "取引可能",
  "verdict_watch": "ウォッチ",
  "pressure_accumulation": "買い集め",
  "pressure_distribution": "分散",
  "reason_take_profit": "テイクプロフィット",
  "reason_liquidation": "ロスカット",
  "reason_stop_loss": "ストップロス",
  "reason_trailing_take_profit": "トレイリングテイクプロフィット",
  "reason_trailing_stop": "トレイリングストップ",
  "reason_signal_flip": "シグナル反転",
  "welcome": "ようこそ",
  "trader": "トレーダー",
  "live": "ライブ",
  "verify_email_banner": "取引を開始するにはメールを確認してください。受信トレイで確認リンクをご確認ください。",
  "resend": "再送",
  "verification_sent": "確認メールを送信しました",
  "could_not_resend": "再送できませんでした",
  "search_coin_placeholder": "銘柄を検索（例：BTC、PEPE、ARB）",
  "add_to_watchlist": "ウォッチリストに追加",
  "free_balance": "利用可能残高",
  "in_positions": "ポジション中",
  "total_equity": "総資産",
  "watchlist": "ウォッチリスト",
  "watchlist_empty": "銘柄はまだありません — 検索して + をタップして追加してください。",
  "high_exposure": "利用可能残高の{percent}%を使用中 — エクスポージャーが高いです。",
  "advanced_tpsl": "詳細TP / SL",
  "entry_optional": "エントリー（任意 — デフォルトは成行）",
  "market": "成行",
  "take_profit_price": "テイクプロフィット価格",
  "stop_loss_price": "ストップロス価格",
  "tp_example": "例：72000",
  "sl_example": "例：66000",
  "if_tp_hits": "TPに到達した場合",
  "if_sl_hits": "SLに到達した場合",
  "pnl_preview_note": "証拠金${amount} × {leverage}xに基づく。ラインはチャートに表示 →",
  "clear_tpsl": "TP/SLをクリア",
  "one_tap_trade": "ワンタップトレード",
  "tp_short": "TP",
  "sl_short": "SL",
  "auto_signals": "自動シグナル",
  "add_token_placeholder": "トークンを追加（例：ARB、OP、TIA）",
  "analyze": "分析",
  "analyzing_on": "{symbol}を{tf}で分析中…",
  "tap_to_load": "タップしてチャートに読み込む →",
  "scanning_market": "マーケットをスキャン中…",
  "no_signals": "シグナルはまだありません。",
  "money_depth": "資金の厚み",
  "sr_zones": "S/Rゾーン",
  "bot_analysis": "ボット分析",
  "confidence": "信頼度",
  "reasoning": "根拠",
  "tp_label": "テイクプロフィット",
  "sl_label": "ストップロス",
  "risk_reward": "リスク : リワード",
  "levels_from_position": "オープンポジションのライブ水準",
  "levels_suggested": "推奨水準 · 投資助言ではありません",
  "toast_opened": "{symbol} {leverage}xのポジションを開きました",
  "toast_closed": "{symbol}を決済 · 損益 ${pnl}",
  "toast_closed_pnl": "決済 · 損益 ${pnl}",
  "ago_s": "{n}秒前",
  "ago_m": "{n}分前",
  "ago_h": "{n}時間前",
  "ago_d": "{n}日前",
  "in_label": "流入",
  "out_label": "流出",
  "confirm_reveal_email": "このユーザーのメールアドレスを表示しますか？メールアドレスは非公開です — 必要なときのみご確認ください。",
  "view_email_private": "メールを表示（非公開）",
  "display_name_updated": "表示名を更新しました",
  "change_email_sent": "新しいメールアドレスに確認リンクを送信しました",
  "username_updated": "ユーザー名を更新しました",
  "password_changed": "パスワードを変更しました。他の端末でも再度ログインしてください。",
  "confirm_logout_all": "すべての端末からログアウトしますか？再度ログインが必要になります。",
  "no_wallet": "ウォレット拡張機能が検出されませんでした（MetaMask/WalletConnect）。",
  "wallet_rejected": "ウォレットの接続が拒否されました。",
  "profile_security": "プロフィールとセキュリティ",
  "display_name": "表示名",
  "display_name_optional": "表示名（任意）",
  "edit": "編集",
  "cancel": "キャンセル",
  "change": "変更",
  "in_days": "{days}日後",
  "username_label": "ユーザー名",
  "username_hint": "3～20文字の英数字またはアンダースコア。変更は30日に1回可能です。",
  "username_example": "例：arash_king",
  "email_private": "メール（非公開）",
  "change_email": "メールを変更",
  "unverified": "未確認",
  "resend_verification": "確認を再送",
  "new_email": "新しいメール",
  "current_password": "現在のパスワード",
  "new_password": "新しいパスワード",
  "confirm_new_password": "新しいパスワードを確認",
  "send_verification_new": "新しいメールに確認を送信",
  "change_email_hint": "新しいメールに送信されるリンクで確認し、その後再度ログインしてください。",
  "email_private_hint": "メールアドレスが公開されることはありません。ここでご本人のみが確認できます。",
  "sessions": "セッション",
  "logout_all_devices": "すべての端末からログアウト",
  "change_password": "パスワードを変更",
  "pw_hint": "8文字以上、英字と数字を含めてください。",
  "update_password": "パスワードを更新",
  "coin_example_placeholder": "例：BTC、PEPE、TAO...",
  "username_or_email": "ユーザー名またはメール",
  "forgot_password_q": "パスワードをお忘れですか？",
  "invalid_email": "有効なメールアドレスを入力してください",
  "pw_mismatch": "パスワードが一致しません",
  "username_hint_short": "3～20文字の英数字またはアンダースコア",
  "account_created_verify": "アカウントを作成しました！メールを確認してアカウントを認証してください。",
  "confirm_password_label": "パスワードを確認",
  "missing_verify_token": "確認トークンがありません。",
  "email_verified_msg": "メールを確認しました！",
  "verification_failed": "確認に失敗しました。",
  "verifying_email": "メールを確認しています…",
  "email_verified_title": "メール確認済み",
  "go_to_login": "ログインへ",
  "verification_failed_title": "確認に失敗しました",
  "verify_expired_hint": "リンクの期限が切れましたか？ログインして、設定の「確認を再送」をご利用ください。",
  "back_to_login": "← ログインに戻る",
  "forgot_password": "パスワードをお忘れの方",
  "forgot_subtitle": "ユーザー名またはメールアドレスを入力してください。リセットリンクをお送りします。",
  "forgot_sent_toast": "アカウントが存在する場合、リセットリンクを送信しました。",
  "forgot_sent_full": "アカウントが存在する場合、リセットリンクを送信しました。メールをご確認ください（15分間有効）。",
  "send_reset_link": "リセットリンクを送信",
  "remembered_it": "思い出しましたか？",
  "missing_reset_token": "リセットトークンがありません。メールのリンクをご利用ください。",
  "pw_requirement": "パスワードは8文字以上で、英字と数字を含めてください",
  "password_updated": "パスワードを更新しました。",
  "reset_password": "パスワードをリセット",
  "reset_subtitle": "アカウントの新しいパスワードを選択してください。",
  "reset_invalid": "リセットリンクが無効またはありません。新しいものをリクエストしてください。",
  "request_reset_link": "リセットリンクをリクエスト",
  "new_password_label": "新しいパスワード",
  "pw_hint2": "8文字以上で、英字と数字を含めてください。",
  "update_password_btn": "パスワードを更新",
  "bullish": "強気",
  "bearish": "弱気",
  "inflow": "流入",
  "outflow": "流出",
  "volume_up": "出来高増加",
  "volume_down": "出来高減少",
  "money_flow_mfi": "マネーフロー (MFI 14)",
  "flow_overbought": "買われすぎ",
  "flow_oversold": "売られすぎ",
  "flow_bullish": "強気の流入",
  "flow_bearish": "弱気の流出",
  "support": "サポート",
  "resistance": "レジスタンス",
  "available_for_trade": "取引可能額",
  "free_balance_after": "取引後の利用可能残高",
  "tab_major": "メジャー",
  "tab_shitcoins": "シットコイン",
  "tab_nfts": "NFT",
  "filter_direction": "方向",
  "buy_only": "買いのみ",
  "sell_only": "売りのみ",
  "min_confidence": "最小信頼度",
  "confirm": "確認",
  "safety_score": "安全性スコア",
  "liquidity_lock": "流動性ロック",
  "locked": "ロック済み",
  "unlocked": "ロック解除",
  "honeypot": "ハニーポット",
  "honeypot_safe_label": "安全",
  "honeypot_risk": "リスク",
  "nft_demo_notice": "デモ取引 — 実際のNFTは購入されません",
  "view_on_opensea": "OpenSeaで表示",
  "volume_24h": "取引量 (24時間)",
  "nft_position_opened": "NFTポジションを開きました（デモ）",
  "crypto_positions_title": "暗号資産＆シットコインのポジション",
  "nft_positions_title": "NFTポジション",
  "min_safety_required": "取引するには安全性スコアが75以上必要です",
  "amount_exceeds_balance": "金額が利用可能残高を超えています",
  "amount_gt_zero": "金額は0より大きくしてください",
  "confirm_trade": "取引を確定",
  "usd_equiv": "≈",
  "nft_badge": "NFT",
  "no_nft_positions": "オープン中のNFTポジションはありません",
  "floor": "フロア",
  "rr_short": "リスクリワード比",
  "best_marketplace": "最良のマーケット",
  "story": "ストーリー",
  "show_more": "もっと見る",
  "show_less": "閉じる",
  "view_chart": "チャートを表示",
  "reason_sma_bull": "SMA9がSMA21を上回る（強気トレンド）",
  "reason_sma_bear": "SMA9がSMA21を下回る（弱気トレンド）",
  "reason_rsi_oversold": "売られすぎ",
  "reason_rsi_overbought": "買われすぎ",
  "reason_rsi_neutral": "中立",
  "reason_pos_momentum": "ポジティブなモメンタム",
  "reason_neg_momentum": "ネガティブなモメンタム",
  "reason_insufficient": "データ不足",
  "reason_whale_accum": "クジラの買い集め",
  "reason_rising_floor": "フロア上昇",
  "reason_falling_floor": "フロア下落",
  "reason_high_rarity": "高レアリティ",
  "reason_mid_rarity": "中レアリティ",
  "nft_trade_history": "NFT取引履歴",
  "no_nft_trades": "決済済みのNFT取引はまだありません",
  "entry_floor": "エントリー時フロア",
  "exit_floor": "エグジット時フロア",
  "verify_reminder": "メールがまだ確認されていません — 確認すると取引が利用できます。",
  "verify_now": "今すぐ確認",
  "dismiss": "閉じる",
  "trusted_devices": "アクティブなセッション · ログイン中の端末",
  "font_size": "フォントサイズ",
  "font_small": "小",
  "font_medium": "中",
  "font_large": "大",
  "sessions_hint": "現在アカウントにログインしているスマートフォンとブラウザ（取引所のAPIキーではありません）。",
  "unknown_device": "不明な端末",
  "this_device": "この端末",
  "current_session": "現在",
  "last_active": "最終アクティブ",
  "revoke_all_others": "他のすべての端末からログアウト",
  "revoke_all_others_done": "他のすべての端末からログアウトしました",
  "no_other_devices": "他にアクティブな端末はありません",
  "device_revoked": "デバイスをログアウトしました",
  "ui_logo_alt": "Firebird / Simorgh Tradeロゴ",
  "ui_logo_switch_hint": "タップしてロゴを切り替え",
  "ui_vpn_info": "VPN情報"
};
export default ja;
